import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import Slider from 'react-slick';
import { bindGa } from 'helpers/analytics';
import { getImageFromImageObject } from 'components/Image/utils';
import s from './Accordion.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import Card from '../../../../../components_v2/common/CardV2';

class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
    };
  }

  onItemClick(e, index) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      activeIndex: index,
    });
  }

  getGAVal = (gaData, data) => {
    if (typeof gaData !== 'string' || !gaData) {
      return '';
    }
    let type = 'Article';
    if (data.hasVideo || data.type === 'video' || data.tn === 'video') {
      type = 'Video';
    } else if (data.type === 'photostory' || data.tn === 'photostory') {
      type = 'Photo';
    }
    return gaData.replace('$type', type);
  };

  clubGAindex = (newga, index, url) => {
    const spaceRemoverGA = newga.replace(/ /g, '');
    const updated = `${spaceRemoverGA + index}#${url}`;
    return updated;
  };

  @bindGa({})
  // eslint-disable-next-line class-methods-use-this
  onActiveItemClick() {
    // dummy fn to capture ga
  }
  getImage = data => {
    const imageSrc = getImageFromImageObject(
      data.image || { id: data.imageid, version: data.imagesize, width: '100' },
    );
    return imageSrc;
  };

  getCardListNew = (data, ga4Type, ga4Category) =>
    data &&
    data.length > 0 &&
    data.map((item, index) => (
      <Card
        data={item}
        isVerticalTile
        imgWidth="200"
        gaIndex={index + 1}
        ga4Type={ga4Type}
        ga4Category={ga4Category}
      />
    ));

  getCardList = (newga, data, ga4Type, ga4Category) =>
    // const ImageElement = this.context ? ImageV2 : Image;

    data.map((item, index) => (
      <div
        className={classNames({
          [`${s.movieReview}`]: true,
          // index === this.state.activeIndex,
        })}
        key={item.id}
      >
        <Link
          to={item.wu}
          onClick={e => {
            if (this.state.activeIndex !== index) {
              this.onItemClick(e, index);
            } else {
              this.onActiveItemClick(e);
            }
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_click',
                type: ga4Type,
                category: `${'story_click' || ga4Category}`,
                story_no: `${index + 1}`,
                msid: item?.id,
              });
            }
          }}
          // data-newga={this.getGAVal(
          //   `${newga}/${index}/${item.wu}`,
          //   item,
          // )}
          data-newga={this.clubGAindex(newga, index + 1, item.wu)}
          target={item.target === '_blank' ? item.target : ''}
        >
          <div className={s.img}>
            <Image src={this.getImage(item)} alt="" lazyload={!(index > 2)} />
          </div>
          <div className={s.content}>
            {/* <h6>Movie Review</h6> */}
            <h2>{item.hl}</h2>
            <p>{item.syn || item.des}</p>
            <div className={s.flexbox}>
              <span>Critic Rating</span>
              <span className={s.rating}>{item.rating}</span>
            </div>
          </div>
        </Link>
      </div>
    ));

  render() {
    const {
      data,
      newga,
      wrapperClass,
      innerWrapperClass,
      slideFlag,
      ga4Type,
      ga4Category,
      cardSlider,
    } = this.props;
    const sliderItems = data;
    const slidesCount = this.props.isPrime || cardSlider ? 3 : 2;
    const settings = {
      slidesToShow: slidesCount,
      slidesToScroll: slidesCount,
      arrows: true,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: cardSlider ? 3 : 2,
          },
        },
      ],
    };
    return (
      <div
        className={`${s.moviereview_wrapper} ${wrapperClass} ${
          slideFlag ? s.isSlide : ''
        } ${cardSlider ? s.cardSlider : ''} slick_UI`}
      >
        {slideFlag &&
          !cardSlider &&
          sliderItems instanceof Array && (
            <Slider {...settings}>
              {this.getCardList(newga, data, ga4Type, ga4Category)}
            </Slider>
          )}

        {cardSlider &&
          sliderItems instanceof Array && (
            <Slider {...settings}>
              {this.getCardListNew(data, ga4Type, ga4Category)}
            </Slider>
          )}

        {!slideFlag &&
          data &&
          data.length > 0 &&
          data.map((item, index) => {
            const imageSrc = getImageFromImageObject(
              item.image || { id: item.imageid, version: item.imagesize },
            );
            return (
              <div
                className={classNames({
                  [`${s.movieReview}`]: true,
                  [`${innerWrapperClass}`]: innerWrapperClass,
                  // index === this.state.activeIndex,
                })}
                key={item.id}
              >
                <Link
                  to={item.wu}
                  onClick={e => {
                    if (this.state.activeIndex !== index) {
                      this.onItemClick(e, index);
                    } else {
                      this.onActiveItemClick(e);
                    }
                    // if (ga4Type) {
                    //   analyticsWrapper('ga4', {
                    //     event: 'user_click',
                    //     type: ga4Type,
                    //     category: `${'story_click' || ga4Category}`,
                    //     story_no: `${index + 1}`,
                    //   });
                    // }
                  }}
                  // data-newga={this.getGAVal(
                  //   `${newga}/${index}/${item.wu}`,
                  //   item,
                  // )}
                  data-newga={this.clubGAindex(newga, index + 1, item.wu)}
                  target={item.target === '_blank' ? item.target : ''}
                >
                  <div className={s.img}>
                    <Image src={imageSrc} lazyload alt="" />
                  </div>
                  <div className={s.content}>
                    {/* <h6>Movie Review</h6> */}
                    <h2>{item.hl}</h2>
                    <p>{item.syn || item.des}</p>
                    <div className={s.flexbox}>
                      <span>Critic Rating</span>
                      <span className={s.rating}>{item.rating}</span>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
      </div>
    );
  }
}

Accordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  newga: PropTypes.string,
  wrapperClass: PropTypes.string,
  innerWrapperClass: PropTypes.string,
  isPrime: PropTypes.bool,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

Accordion.defaultProps = {
  newga: 'Accordian',
  wrapperClass: '',
  innerWrapperClass: '',
  isPrime: false,
  ga4Type: '',
  ga4Category: '',
};

export default Accordion;
